class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    // Adiciona evento de tecla "Escape" para fechar o modal
    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());

    // Adiciona evento de clique no summary para abrir/fechar o modal
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));

    // Adiciona evento de clique no botão de fechar (se existir)
    const closeButton = this.querySelector('button[type="button"]');
    if (closeButton) {
      closeButton.addEventListener('click', this.close.bind(this));
    }

    // Adiciona evento de clique no botão de reset APENAS no mobile
    const resetButton = this.querySelector('button[type="reset"]');
    if (resetButton && this.isMobile()) {
      resetButton.addEventListener('click', () => {
        const input = this.querySelector('input[type="text"]');
        if (input) input.value = ''; // Limpa o campo de pesquisa
        this.close(); // Fecha o modal
      });
    }

    // Define o summary como um botão para acessibilidade
    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    console.log("onSummaryClick", event.target);
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
  }

  isMobile() {
    return window.innerWidth < 768; // Define o breakpoint para mobile
  }
}

customElements.define('details-modal', DetailsModal);

class DetailsModalSearch extends DetailsModal {
  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden-search');

    // WCAG 2.4.3: keep keyboard/AT from reaching the page behind the modal
    this.setPageInert(true);

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );

    this.querySelector('predictive-search')?.getInitialResults();
  }

  close(focusToggle = true) {
    this.setPageInert(false);
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden-search');
  }

  setPageInert(inert) {
    const main = document.getElementById('MainContent');
    const footers = document.querySelectorAll('footer');
    if (main) main.inert = inert;
    footers.forEach((el) => (el.inert = inert));
  }
}

customElements.define('details-modal-search', DetailsModalSearch);
